import {
  DocumentOrganizationKeys,
  FilterOptionKeys,
  Goal,
  GoalFilterDocument,
  GoalSortingMode,
  GroupByMode,
  ID,
} from '@griply/types';

export const getSubGoalsGoalFilterDocument = (
  goal: Goal | undefined,
  subGoalIds: ID[],
): GoalFilterDocument => {
  const base: GoalFilterDocument = goal?.goalFilterDocument ?? {
    [DocumentOrganizationKeys.GroupByMode]: GroupByMode.None,
  };

  return {
    ...base,
    [DocumentOrganizationKeys.GroupByMode]:
      base.groupByMode ?? GroupByMode.None,
    [DocumentOrganizationKeys.SortingMode]:
      base.sortingMode ?? goal?.goalSortingMode ?? GoalSortingMode.StartDate,
    [DocumentOrganizationKeys.Filters]: {
      ...(base[DocumentOrganizationKeys.Filters] ?? {}),
      [FilterOptionKeys.Goal]: {
        include: [...subGoalIds],
      },
    },
    [DocumentOrganizationKeys.CollapsedSections]:
      base[DocumentOrganizationKeys.CollapsedSections] ??
      goal?.collapsedSubGoals ??
      subGoalIds,
  };
};
